/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Th4Inputs */

const en_mk_cmp_clickup_th4 = /** @type {(inputs: Mk_Cmp_Clickup_Th4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It has built-in Chat inside the product.`)
};

const id_mk_cmp_clickup_th4 = /** @type {(inputs: Mk_Cmp_Clickup_Th4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada Chat bawaan di dalam produk.`)
};

/**
* | output |
* | --- |
* | "It has built-in Chat inside the product." |
*
* @param {Mk_Cmp_Clickup_Th4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_th4 = /** @type {((inputs?: Mk_Cmp_Clickup_Th4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Th4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_th4(inputs)
	return en_mk_cmp_clickup_th4(inputs)
});